import React from 'react';
import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
} from '@mui/material/styles';

import { theme as styledTheme } from './ThemeProvider';

const muiTheme = createTheme({
  palette: {
    primary: {
      main: styledTheme.colors.primary,
      contrastText: styledTheme.colors.black2,
    },
    secondary: {
      main: styledTheme.colors.secondary,
    },
    info: {
      main: styledTheme.colors.info,
    },
    text: {
      primary: styledTheme.colors.text.primary,
      secondary: styledTheme.colors.text.secondary,
    },
    background: {
      default: styledTheme.colors.background,
      paper: styledTheme.colors.background,
    },
  },
  typography: {
    fontFamily: styledTheme.fonts.primary,
    h1: {
      fontSize: styledTheme.typography.h1.size,
      fontWeight: styledTheme.typography.h1.weight,
      lineHeight: styledTheme.typography.h1.lineHeight,
    },
    h2: {
      fontSize: styledTheme.typography.h2.size,
      fontWeight: styledTheme.typography.h2.weight,
      lineHeight: styledTheme.typography.h2.lineHeight,
    },
    body1: {
      fontSize: styledTheme.typography.body.default.size,
      fontWeight: styledTheme.typography.body.default.weight,
      lineHeight: styledTheme.typography.body.default.lineHeight,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
});

type MuiThemeProviderProps = {
  children: React.ReactNode;
};

export const CustomMuiThemeProvider = ({ children }: MuiThemeProviderProps) => (
  <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>
);
